import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import FieldDetail from './FieldDetail';

export default function ATMDetail({ atmName, atmLocation, surcharge }) {
  if (!atmName && !atmLocation && !surcharge) {
    return null;
  }

  return (
    <>
      <Divider />
      <Grid
        columnSpacing="8px"
        container
        pb={{ xs: '24px', md: '56px' }}
        pt={{ xs: '24px', md: '32px' }}
        px={{ xs: '24px', md: '32px' }}
        rowSpacing={{ xs: '16px', md: '32px' }}
      >
        <Grid
          item
          xs={12}
        >
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Text
              color="primary"
              size="xl"
              weight="medium"
            >
              ATM Details
            </Text>
          </Stack>
        </Grid>
        <FieldDetail
          label="ATM Name"
          value={atmName}
        />
        <FieldDetail
          label="ATM Location"
          value={atmLocation}
        />
        <FieldDetail
          label="ATM Surcharge"
          value={surcharge}
        />
      </Grid>
    </>
  );
}

ATMDetail.propTypes = {
  atmName: PropTypes.string,
  atmLocation: PropTypes.string,
  surcharge: PropTypes.string
};
